import _ from "lodash";
// import PropTypes from 'prop-types';
import React from "react";
import classes from "./GradeComponent.scss";

import ClassCard from "../../ClassCard";
import ClassCardV2 from "Courses/components/components/ClassCardV2";
class GradeComponent extends React.PureComponent {
  render() {
    const {
      grade: { id, courses, name },
      onClassSelect,
      showRightPane,
      styles = {},
      showSelectedIcon,
      selectedIds = [],
      showCount = false,
      isMapleBearLikeOrg,
      isToddleLibrary,
    } = this.props;

    const classCardList = _.map(courses, (course, index) => {
      return isToddleLibrary ? (
        <ClassCardV2
          course={course}
          key={course.id}
          onClassSelect={onClassSelect}
          selected={_.includes(selectedIds, course.id)}
        />
      ) : (
        <ClassCard
          course={course}
          key={course.id}
          count={index}
          onClassSelect={onClassSelect}
          showCount={showCount}
          containerStyle={{
            borderLeftWidth: 4,
            borderRadius: 4,
            height: 80,
          }}
          showSelectedIcon={showSelectedIcon}
          selected={_.includes(selectedIds, course.id)}
          isMapleBearLikeOrg={isMapleBearLikeOrg}
        />
      );
    });

    const containerStyle = styles.container || {};
    const listStyle = styles.list || {};

    return (
      <div className={classes.container} style={containerStyle}>
        <div className={classes.gradeDiv}>{name}</div>
        <div className={classes.gradeCardsDiv} style={listStyle}>
          {classCardList}
        </div>
      </div>
    );
  }
}

export default GradeComponent;
